// Full-document render of the store-locator state index inside PageSkeleton.
// All copy is ttag `t` (localizes at runtime for fr_CA); the state links +
// counts arrive pre-resolved as props.
import React from "react";
import { t } from "ttag";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

// Mutable reactivated props (not Immutable<>): composes PageSkeleton.
type IProps = templates.LocationsByStateTemplate;

export const Template = (props: IProps): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="store-locator">
                <div className="store-locator__hero l-full-width">
                    <h1 className="store-locator__hero-title">
                        {t`Find a Retailer`}
                    </h1>
                </div>

                <div className="l-capped-width">
                    <nav
                        className="breadcrumb"
                        role="region"
                        aria-label={t`breadcrumbs`}
                    >
                        <ul className="breadcrumb__list">
                            <li className="breadcrumb__list-item">
                                <a href={props.home_url}>{t`Home`}</a>
                            </li>
                            <li className="breadcrumb__list-item">
                                <a href={props.store_locator_url}>
                                    {t`Store Locator`}
                                </a>
                            </li>
                            <li
                                className="breadcrumb__list-item"
                                aria-current="page"
                            >
                                <a href={props.find_retailer_url}>
                                    {t`Find a Retailer`}
                                </a>
                            </li>
                        </ul>
                    </nav>

                    <div className="store-locator__header">
                        <h2 className="store-locator__title">
                            {t`Find a Tempur-Pedic Mattress Retailer`}
                        </h2>
                        <p className="store-locator__description">
                            {t`Browse state-by-state, city-by-city, for the Tempur-Pedic retailer of your choice.`}
                        </p>
                    </div>
                    <div className="store-locator__list">
                        <div className="store-locator__list-container">
                            {props.states.map((state) => (
                                <span
                                    key={state.state}
                                    className="store-locator__list-item"
                                >
                                    <a
                                        className="store-locator__list-link"
                                        href={state.url}
                                    >
                                        {state.state_name}{" "}
                                        <span className="store-locator__list-link__count">
                                            ({state.store_count})
                                        </span>
                                    </a>
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </PageSkeleton>
    );
};
